import './index.css'
import cn from 'clsx'
import * as React from 'react'
import { connect } from 'react-redux'
import type { Track } from 'types/track'
import type { TrackOptions } from '@disco/state-management/actions/MediaActions'
import * as MediaActions from '@disco/state-management/actions/MediaActions'
import { PLAYING } from '@disco/constants/MediaStatus'
import { getTrackPlaybackStatus } from '@disco/state-management/selectors/media'
import Icon from 'components/ui/icon'

function mapStateToProps(state, props) {
  return {
    ...getTrackPlaybackStatus(state, {
      trackId: props.track.id,
    }),
  }
}

type Props = {
  mediaSource: string
  pauseTrack: (...args: Array<any>) => any
  playTrack: (...args: Array<any>) => any
  children: React.ReactNode
  playbackStatus: string
  playbackContext: TrackOptions
  track: Track
  isVideoFile?: boolean
  disableActions?: boolean
  onClick?: (...args: Array<any>) => any
  shadow?: boolean
}

class MediaControl extends React.Component<Props> {
  _handleClick = (event: React.SyntheticEvent<any>) => {
    const {
      mediaSource,
      pauseTrack,
      playTrack,
      playbackStatus,
      playbackContext,
      track,
      disableActions,
      onClick,
    } = this.props
    if (onClick) onClick()
    if (disableActions) return

    if (playbackStatus === PLAYING) {
      pauseTrack(track.id)
    } else {
      playTrack(track.id, mediaSource, playbackContext)
    }
  }

  render() {
    const { children, playbackStatus, isVideoFile, shadow } = this.props
    return (
      <div
        className={cn('media-control', {
          'media-control--active': playbackStatus === PLAYING,
          'media-control--video': isVideoFile,
          'media-control--shadow': shadow,
        })}
        data-testid="media-control"
        onClick={this._handleClick}
      >
        <div
          className={cn('media-control-button', {
            'media-control-button--video': isVideoFile,
          })}
        >
          <div className="media-control-icon">
            <Icon
              type={playbackStatus === PLAYING ? 'pause' : 'play'}
              width={36}
              height={36}
            />
          </div>
        </div>

        {children}
      </div>
    )
  }
}

export default connect(mapStateToProps, MediaActions)(MediaControl) as any
